import React from "react";

import {pluralize} from "@pg-mono/string-utils";

interface IOfferDetailGeneratedDescriptionStorage {
    storage: {
        quantity: number;
        description: string;
        price: number;
    };
}

const storageQuantity = pluralize(["znajduje się", "znajdują się", "znajduje się"]);
const storageQuantityPlural = pluralize(["komórka lokatorska", "komórki lokatorskie", "komórek lokatorskich"]);

export const OfferDetailGeneratedDescriptionStorage = ({storage}: IOfferDetailGeneratedDescriptionStorage) => {
    if (!storage) {
        return null;
    }

    return (
        <p>
            {`W inwestycji ${
                storage.quantity
                    ? ` ${storageQuantity(storage.quantity)} ${storage.quantity} ${storageQuantityPlural(storage.quantity)}${
                          storage.description ? ` ${storage.description}.` : "."
                      }`
                    : `znajdują się komórki lokatorskie${storage.description ? ` ${storage.description}.` : "."}`
            }`}
        </p>
    );
};
import React from "react";

import {pluralize} from "@pg-mono/string-utils";

interface IOfferDetailGeneratedDescriptionStorage {
    storage: {
        quantity: number;
        description: string;
        price: number;
    };
}

const storageQuantity = pluralize(["znajduje się", "znajdują się", "znajduje się"]);
const storageQuantityPlural = pluralize(["komórka lokatorska", "komórki lokatorskie", "komórek lokatorskich"]);

export const OfferDetailGeneratedDescriptionStorage = ({storage}: IOfferDetailGeneratedDescriptionStorage) => {
    if (!storage) {
        return null;
    }

    return (
        <p>
            {`W inwestycji ${
                storage.quantity
                    ? ` ${storageQuantity(storage.quantity)} ${storage.quantity} ${storageQuantityPlural(storage.quantity)}${
                          storage.description ? ` ${storage.description}.` : "."
                      }`
                    : `znajdują się komórki lokatorskie${storage.description ? ` ${storage.description}.` : "."}`
            }`}
        </p>
    );
};
